import { render } from "./ClientLegalInfo.vue?vue&type=template&id=f718dae2&scoped=true"
import script from "./ClientLegalInfo.vue?vue&type=script&lang=js"
export * from "./ClientLegalInfo.vue?vue&type=script&lang=js"

import "./ClientLegalInfo.vue?vue&type=style&index=0&id=f718dae2&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f718dae2"]])

export default __exports__